import React, {createContext, ReactNode, useContext, useEffect} from 'react';

import {KYC_IDV_DOCS_SUBMITTED_EVENTS} from '@/app/auth/events/KycIdvDocsSubmittedEvents';

import {useTrackers} from './trackers';

type ViewModelContextType = {};

const ViewModelContext = createContext<ViewModelContextType | undefined>(
  undefined,
);

export function ViewModelProvider({children}: {children: ReactNode}) {
  const {trackIdvDocsSubmitted} = useTrackers();

  useEffect(() => {
    trackIdvDocsSubmitted(
      KYC_IDV_DOCS_SUBMITTED_EVENTS.VIEW_KYC_IN_REVIEW_IDV_DOCS_SUBMITTED_PAGE,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ViewModelContext.Provider value={{}}>{children}</ViewModelContext.Provider>
  );
}

export function useViewModelProvider() {
  const context = useContext(ViewModelContext);
  if (context === undefined) {
    throw new Error(
      'Kyc In Rewiew Idv Docs Submitted ViewModelContext is undefined',
    );
  }
  return context;
}
